{
  "add_contact": "Add contact",
  "add_profession": "Add profession",
  "remove_profession": "remove profession",
  "update_contact": "Update contact",
  "lastName_placeholder": "last name",
  "firstName_placeholder": "first name",
  "lastName": "Last name",
  "firstName": "First name",
  "Email": "email",
  "description": "Description"
}
